import OnboardingCover from '@pngs/AboutUsPage/ambassador4.png';

export const learningMapPageLayoutByVariant = {
  desktop: {
    pl: 156,
    pr: 156,
    px: 156,
  },
  laptop: {
    pl: 24,
    pr: 24,
    px: 24,
  },
  mobile: {
    pl: 16,
    pr: 16,
    px: 16,
  },
  tablet: {
    pl: 24,
    pr: 24,
    px: 24,
  },
};

export const getOnboardingModule = ({
  i18n,
  isCompleted,
  isHighlightedOnMap,
}) => ({
  id: 0,
  image: OnboardingCover,
  is_completed: isCompleted,
  is_highlighted_on_map: isHighlightedOnMap,
  lessons: [
    {
      id: 0,
      is_available: true,
      is_completed: isCompleted,
      is_highlighted_on_map: isHighlightedOnMap,
      title: i18n.t('LearningMapPage.Buttons.Onboarding'),
    },
  ],
  title: i18n.t('CoursesPage.Onboarding'),
});

export const getCertificationModule = ({
  course,
  i18n,
  isHighlightedOnMap,
}) => ({
  id: 0,
  image: `https://geneva-learning-platform-resources.s3.eu-north-1.amazonaws.com/images/modules/certification-${course?.id}.png`,
  is_completed: course?.is_passed,
  is_highlighted_on_map: isHighlightedOnMap,
  lessons: [
    {
      id: 0,
      is_available: true,
      is_completed: course?.is_passed,
      is_highlighted_on_map: isHighlightedOnMap,
      title: i18n.t('LearningMapPage.Buttons.Certification'),
    },
  ],
  title: i18n.t('Certification.Title'),
});
